import { ReactComponent as Api } from 'assets/icons/Api.svg';

interface ApiKeysStatePanelProps {
  title: string;
  description: string;
  dataTestId: string;
}

/** Centered icon-tile + title + body used by the no-access and REST-disabled tab states. */
const ApiKeysStatePanel = ({ title, description, dataTestId }: ApiKeysStatePanelProps) => (
  <div className="flex flex-col items-center justify-center gap-2 px-4 py-12 text-center" data-testid={dataTestId}>
    <div className="bg-tertiary-10 flex h-12 w-12 items-center justify-center rounded-xl">
      <Api className="text-tertiary-50 stroke-1.5 h-6 w-6 stroke-current" />
    </div>
    <span className="text-grayscale-black max-w-xs text-base font-semibold">{title}</span>
    <span className="text-gray-80 text-size-sm max-w-xs">{description}</span>
  </div>
);

export default ApiKeysStatePanel;
